import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const MaskedLine = ({ children, delay, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Hero = () => {
  return (
    <section id="top" className="relative flex min-h-svh flex-col items-center justify-center overflow-hidden px-6 pb-14 pt-28 text-center" data-testid="hero-section">
      <motion.div
        className="relative z-10 mx-auto w-[min(60vw,400px)]"
        data-testid="hero-logo-mark"
        initial={{ opacity: 0, scale: 0.86, rotate: -8 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ duration: 1.2, ease: EASE }}
      >
        <img
          src="/housegemacht-text.png"
          alt="Housegemacht — The Home of House"
          className="block w-full"
        />
        <img
          src="/housegemacht-globe.png"
          alt=""
          aria-hidden="true"
          className="animate-spin-mark absolute inset-0 block h-full w-full"
          style={{ transformOrigin: "49.11% 52.15%" }}
        />
      </motion.div>

      <div className="relative z-10 mt-12">
        <MaskedLine delay={0.25} className="font-mono2 text-sm font-bold uppercase tracking-[0.22em] text-[#f4f4f2] md:text-xl">
          Hausgemachte House-Partys
        </MaskedLine>
        <div className="mx-auto mt-8 max-w-5xl text-2xl font-semibold leading-tight text-[#f4f4f2] md:text-4xl">
          <MaskedLine delay={0.4}>Kein Club von der Stange.</MaskedLine>
          <MaskedLine delay={0.5}>Housegemacht bringt House-Musik dorthin,</MaskedLine>
          <MaskedLine delay={0.6}>wo sie hingehört — auf die Floors,</MaskedLine>
          <MaskedLine delay={0.7}>die ganz Köln bewegen.</MaskedLine>
          <MaskedLine delay={0.8}>Von uns für die Tanzfläche.</MaskedLine>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.95, ease: EASE }}
          className="mt-10 inline-flex items-center gap-3 rounded-full border-2 border-[#f4f4f2] px-8 py-4 font-mono2 text-sm font-bold tracking-[0.06em] md:text-base"
          data-testid="hero-status-pill"
        >
          <span className="animate-pulse-dot h-2 w-2 rounded-full bg-[#f4f4f2]" />
          Erstes Event in Vorbereitung
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 0.8 }}
        className="relative z-10 mx-auto mt-12 flex w-max flex-col items-center gap-3"
        data-testid="hero-scroll-cue"
      >
        <span className="font-mono2 text-[10px] font-bold uppercase tracking-[0.3em] text-[#a8a8a4]">Scroll</span>
        <span className="animate-cue-line block h-10 w-[2px] bg-[#f4f4f2]" />
      </motion.div>
    </section>
  );
};
